/**
 * Dedicated landing page for the MSAL `redirectUri`
 * (https://adminpanel.thinkcloudly.co/redirect/azure/).
 *
 * This route must exist and must NOT navigate anywhere. When the SSO
 * popup lands here, msal-browser (running in the opener window) polls
 * this popup's URL to read the auth response out of the hash. Without
 * an explicit route for this path, react-router's catch-all
 * (`path="*" -> <Navigate to="/dashboard" />`) matched instead and
 * immediately called history.replaceState, which strips the hash
 * before MSAL can read it — causing the intermittent
 * "hash_empty_error: Hash value cannot be processed because it is
 * empty" login failures. Keep this component free of any redirects,
 * effects, or router logic.
 */
export default function AzureRedirectHandler() {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "100vh",
        fontFamily: "sans-serif",
        color: "#6b7280",
      }}
    >
      Signing you in…
    </div>
  );
}
